import type { ReactNode } from "react";
import { Gmail, GoogleCalendar, Plaid, Stripe } from "@thesvg/react";

import { cn } from "@/utils/Functions";

const iconProps = {
  width: 20,
  height: 20,
  className: "size-5 shrink-0",
  "aria-hidden": true as const,
};

/** DocuSign is not in @thesvg/react yet — minimal brand mark until added upstream. */
function DocuSignIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-5 shrink-0" aria-hidden>
      <rect width="24" height="24" rx="4" fill="#FFCC22" />
      <path
        d="M6.5 14.2c2.2 1.8 4.6 2.3 7.8 2.3 2.4 0 4.2-.4 5.7-1.5"
        fill="none"
        stroke="#003D82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M5.8 12.4c1.6-1.2 3.4-1.8 5.6-1.8"
        fill="none"
        stroke="#003D82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

const CONNECT_BRAND_ICONS: Record<string, ReactNode> = {
  gmail: <Gmail {...iconProps} />,
  gcal: <GoogleCalendar {...iconProps} />,
  stripe: <Stripe {...iconProps} />,
  plaid: <Plaid {...iconProps} className="size-5 max-w-5 shrink-0" />,
  docusign: <DocuSignIcon />,
};

export const CONNECT_ICON_WRAPPER: Record<string, string> = {
  gmail: "bg-[#EA4335]/10",
  gcal: "bg-[#4285F4]/10",
  stripe: "bg-[#635BFF]/10",
  plaid: "bg-black/5 dark:bg-white/10",
  docusign: "bg-[#FFCC00]/15",
};

interface ConnectBrandIconProps {
  sourceId: string;
  className?: string;
}

export function ConnectBrandIcon({ sourceId, className }: ConnectBrandIconProps) {
  const icon = CONNECT_BRAND_ICONS[sourceId];
  if (!icon) return null;

  return <span className={cn("inline-flex items-center justify-center", className)}>{icon}</span>;
}

export function ConnectIconWrapper({
  sourceId,
  connected,
  children,
}: {
  sourceId: string;
  connected?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex size-9 shrink-0 items-center justify-center rounded-lg",
        connected ? "bg-background" : CONNECT_ICON_WRAPPER[sourceId] ?? "bg-background",
      )}
    >
      {children}
    </div>
  );
}
